import styled from 'styled-components';
import { CURRENT_FONT, SELECTORS, TABLET_BREAKPOINT } from '../../../../constants';

interface IFaqContainerProps {
  beforeContent: string;
}

export const ViewAllFAQContainer = styled.div`
    ${SELECTORS} & {
      background: transparent;
      border: 2px solid white;
      color: white;
      width: fit-content;
      position: relative;
      padding: 8px 35px !important;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      border-radius: 100px;
      transition: all 0.12s ease-in-out;
      overflow: hidden;
      cursor: pointer;
      margin: 25px auto 0 auto;
      font-size: 16px;
      &:before {
        content :  ${({ beforeContent }: IFaqContainerProps) => `'${beforeContent}'`};
        font-family: ${props => props.theme.boldFont};
        font-weight: ${props => props.theme.fontWeight};
        transition: all 0.12s ease-in-out;
        opacity: 1;
        color: white;
        font-size: 16px;
        position: absolute;
        text-align: center;
        -webkit-transform: translate3d(0, 56px, 0);
        transform: translate3d(0, 56px, 0);
        display: block;
            line-height: normal;
      }
      
      &:hover{
        &:before {
         transform: translate3d(0, 0, 0);
        }
      }
      
      @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
          &:before {
            font-size: 16px;
          }
        }
      }
      
   }
    
    
    @media (max-width: 600px) { 
      ${SELECTORS} & {
        width: 90%;
        text-align: center;
      }
    }  
`;

export const ViewAllFAQButton = styled.span`
  ${SELECTORS} & {
    transition: all 0.12s ease-in-out;
    display: block;
    font-size: 16px;
    opacity: 1;    
    line-height: normal;
    max-height: 25px;
    
    font-family: ${props => props.theme.boldFont};
    font-weight: ${props => props.theme.fontWeight};
  }
  
  @media (max-width: ${TABLET_BREAKPOINT}) {
      ${SELECTORS} & {
        font-size: 16px;
      }
  }
   
  ${ViewAllFAQContainer}:hover &{
      transform: translate3d(0, -56px, 0);
    }
`;
